import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from 'reactstrap';

import { BtnOutlineGreen } from '../../../styled-components';
import _ from 'lodash';
import { getValidationErrorMessage } from './helpers';
import ExportCSVRow from './ExportCSVRow';
import { useAuth } from '../../../commons/Auth';

function IafPolisImportFeedbackModal({ toggle, isOpen, data = {} }) {
  const [t] = useTranslation('CONTRACTS');
  const [{ newToken } = {}] = useAuth();

  const {
    errors = {},
    updatedContracts = [],
    storniCreatedOrUpdated = 0,
    validationErrors: topValidationErrors,
  } = data;
  let validationErrors = false;
  if (topValidationErrors && Array.isArray(topValidationErrors.message)) {
    validationErrors = topValidationErrors.message;
  }
  if (
    topValidationErrors &&
    topValidationErrors.message &&
    !Array.isArray(topValidationErrors.message)
  ) {
    validationErrors = [topValidationErrors.message];
  }

  const {
    podPdrNotFound = [],
    supplierNoLongerManagingContracts = [],
    stornoContractNotFound = [],
    stornoAlreadyExists = [],
  } = errors;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {validationErrors
          ? t('MALFORMED_FILE')
          : t('IMPORTED_IAF_POLIS_FEEDBACK')}
      </ModalHeader>

      {!validationErrors && (
        <ModalBody>
          <Row>
            <Col sm="12">
              <h5>
                {t('UPDATED_CONTRACTS_NUMBER')}: {updatedContracts?.length || 0}
              </h5>
            </Col>
          </Row>
          {storniCreatedOrUpdated > 0 && (
            <Row>
              <Col sm="12">
                <h5>
                  {t('STORNI_CREATED_OR_UPDATED_NUMBER')}:{' '}
                  {storniCreatedOrUpdated}
                </h5>
              </Col>
            </Row>
          )}
          <Row>
            <Col sm="12">
              <h5>
                {t('NOT_UPDATED_CONTRACTS_NUMBER')}:{' '}
                {_.uniqWith(
                  [
                    ...podPdrNotFound,
                    ...supplierNoLongerManagingContracts,
                    ...stornoContractNotFound,
                    ...stornoAlreadyExists,
                  ],
                  _.isEqual
                ).length || 0}
              </h5>
              <ul>
                <ExportCSVRow
                  data={podPdrNotFound}
                  text={t('POD_PDR_NOT_FOUND')}
                />
                <ExportCSVRow
                  data={supplierNoLongerManagingContracts}
                  text={t('NOT_OF_THIS_SUPPLIER')}
                />
                <ExportCSVRow
                  data={stornoContractNotFound}
                  text={t('STORNO_CONTRACT_NOT_FOUND')}
                />
                <ExportCSVRow
                  data={stornoAlreadyExists}
                  text={t('STORNO_ALREADY_EXISTS')}
                />
              </ul>
            </Col>
          </Row>
        </ModalBody>
      )}
      {validationErrors && (
        <ModalBody>
          <Row>
            <Col sm="12">
              {validationErrors.map((v) => (
                <h5>{getValidationErrorMessage({ message: v })}</h5>
              ))}
            </Col>
          </Row>
        </ModalBody>
      )}
      <ModalFooter>
        <BtnOutlineGreen type="button" className="uppercase" onClick={toggle}>
          {t('COMMON:CLOSE')}
        </BtnOutlineGreen>
      </ModalFooter>
    </Modal>
  );
}

export default IafPolisImportFeedbackModal;
